import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFoundPage() {
    return (
        <div
            className="pt-24 min-h-[80vh] flex items-center"
            data-testid="not-found-page"
        >
            <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center py-24">
                <p className="ssh-eyebrow">404 · Quietly missing</p>
                <h1 className="mt-6 font-serif font-light tracking-tight leading-[1.05] text-5xl sm:text-6xl text-[#2C2B29]">
                    This page hasn't{" "}
                    <em className="italic text-[#A68A6B]">arrived yet.</em>
                </h1>
                <p className="mt-6 text-lg leading-relaxed text-[#4A4947]">
                    Take a breath. Then choose a softer path below.
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                    <Link to="/">
                        <Button
                            className="ssh-btn-primary rounded-none px-9 py-7 text-xs uppercase tracking-[0.22em]"
                            data-testid="not-found-home"
                        >
                            Return Home
                        </Button>
                    </Link>
                    <Link to="/contact#booking">
                        <Button
                            variant="outline"
                            className="rounded-none border-[#2C2B29] bg-transparent text-[#2C2B29] hover:bg-[#2C2B29] hover:text-white px-9 py-7 text-xs uppercase tracking-[0.22em] transition-colors"
                        >
                            Book a Session
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
